/**
 * @generated SignedSource<<278ba2ac195dff448c5cade8cb4739da>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type AccountType = "COLLATERAL" | "CREDIT_CARD_COLLATERAL" | "DEFI_BORROW_COLLATERAL" | "DEFI_YIELD" | "FIAT" | "FIAT_SAVINGS" | "FUTURES_CFM" | "MULTISIG" | "MULTISIG_VAULT" | "PREDICTION_MARKETS_CFM" | "RAISE_INVESTMENTS" | "RETAIL_DEFI_LEND" | "STAKED_FUNDS" | "UNKNOWN" | "VAULT" | "WALLET" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type readFiatWalletAccountFragment$data = {
  readonly assetOrFiatCurrency: {
    readonly __typename: "TiersCurrency";
    readonly code: string;
    readonly name: string;
    readonly type: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null;
  readonly name: string;
  readonly type: AccountType;
  readonly uuid: string;
  readonly " $fragmentSpreads": FragmentRefs<"getIsCountryAllowedAccountFragment" | "readAccountBalanceFragment">;
  readonly " $fragmentType": "readFiatWalletAccountFragment";
};
export type readFiatWalletAccountFragment$key = {
  readonly " $data"?: readFiatWalletAccountFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"readFiatWalletAccountFragment">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "readFiatWalletAccountFragment"
};

(node as any).hash = "bde2a5a32793061708e2a875e5da9dbc";

export default node;
